import {Button, Input, Paper, Theme} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React, {useState} from 'react';
import {T, useT} from 'react-polyglot-hooks';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    marginLeft: theme.spacing(2)
  }
}));

const Search = (props: { className?: string, onSearch: (search:string) => void }) => {
  const {onSearch, className, ...rest} = props;
  const [search, setSearch] = useState('');
  const t = useT();

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Paper
        className={classes.search}
        elevation={1}
      >
        <SearchIcon className={classes.searchIcon}/>
        <Input
            className={classes.searchInput}
            disableUnderline
            placeholder={t('Search').toString()}
            onChange={(event) => setSearch(event.target.value)}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                onSearch(search);
                event.preventDefault();
                event.stopPropagation();
              }
            }}
        />
      </Paper>
      <Button
          type="button"
          className={classes.searchButton}
          onClick={() => onSearch(search)}
          size="large"
          variant="contained"
      >
        <T phrase="Search" />
      </Button>
    </div>
  );
};

export default Search;
